import { useDateContext } from '_/space-management/hooks/DateContext';
import { useEventContext } from '_/space-management/hooks/EventContext';
import { useSlotContext } from '_/space-management/hooks/SlotContext';
import { useSpaceContext } from '_/space-management/hooks/SpaceContext';
import React, { useEffect } from 'react';
import { FlatList, RefreshControl, View } from 'react-native';

import NoReservedList from './NoReservedList';
import WhoReserved from './WhoReserved';

export default function ReservedList() {
  const { reservedList } = useSlotContext();
  const { getReservedList, reservedListLoading } = useEventContext();
  const { spaceId } = useSpaceContext();
  const { selectedEventDate } = useDateContext();

  useEffect(() => {
    getReservedList({
      spaceId,
      startAtTime: selectedEventDate.start,
      endAtTime: selectedEventDate.end,
    });
  }, [selectedEventDate, spaceId]);

  return (
    <View style={{ flex: 1 }}>
      <FlatList
        style={{ flex: 1 }}
        data={reservedList}
        ListEmptyComponent={<NoReservedList />}
        keyExtractor={(item) => item.id}
        renderItem={({ item: event }) => <WhoReserved event={event} />}
        showsVerticalScrollIndicator={false}
        refreshControl={
          <RefreshControl
            refreshing={reservedListLoading}
            onRefresh={async () => {
              await getReservedList({
                spaceId,
                startAtTime: selectedEventDate.start,
                endAtTime: selectedEventDate.end,
              });
            }}
          />
        }
      />
    </View>
  );
}
